<!-- popup for shared resources -->
<div class="fdm-dialog fdm-fade" id="panel-sharable-simple">
    <div class="fdm-overlay-full" (click)="dialogRef.close()"></div>
    <mat-card class="fdm-dropdown-panel">
        <mat-card-header class="header">
            <div translate class="subheading-2 title">NAV.SHAREABLE_RESOURCES</div>
            <div class="header-actions">
                <fa-icon icon="times" class="fdm-link" style="font-size:22px;margin-right:5px;" (click)="dialogRef.close()"></fa-icon>
            </div>
        </mat-card-header>
        <mat-card-content style="padding:40px 10px;">
            <div  class="text-center" *ngIf="loading">
                <mat-spinner style="margin:0 auto;" strokeWidth="3"></mat-spinner>
            </div>
            <div *ngIf="!loading">
                <div translate *ngIf="!transforms || !transforms.length">
                    NAV.NO_SHARES
                </div>

                <table style="width:100%;">
                    <tr *ngFor="let t of transforms">
                        <td style="padding:3px;">{{ t.ds_name }}</td>
                        <td style="padding:3px;">
                            <input *ngIf="t.input && t.input.id" style="background-color:#fff!important;color:#999!important;font-size:11px!important;" 
                            [value]="V.config.host +'/api/Dataset/WMS/' + t.input.id +'/wms?access_token='+ V.token +'&service=WMS&request=GetCapabilities&version=1.3.0'" style="width:100%" /> 
                        </td>
                    </tr>
                </table>

            </div>
        </mat-card-content>
    </mat-card>
</div>